import type { Locale, LocaleMeta } from '../types/locale';

export const locales: LocaleMeta[] = [
  {
    code: 'en',
    nativeName: 'English',
    dir: 'ltr',
    prompt:
      'It looks like you’re in {country}. Would you like to experience Superluxury locally — with content and language suited to where you are?',
    continueLabel: 'Continue',
    closeLabel: 'Close',
  },
  {
    code: 'de',
    nativeName: 'Deutsch',
    dir: 'ltr',
    prompt:
      'Ihr Standort: {country}. Möchten Sie Superluxury lokal erleben – mit Inhalten und einer Sprache, die zu Ihrem Standort passen?',
    continueLabel: 'Weiter',
    closeLabel: 'Schließen',
  },
  {
    code: 'fr',
    nativeName: 'Français',
    dir: 'ltr',
    prompt:
      'Votre emplacement : {country}. Souhaitez-vous découvrir Superluxury localement, avec des contenus et une langue adaptés à votre région ?',
    continueLabel: 'Continuer',
    closeLabel: 'Fermer',
  },
  {
    code: 'pl',
    nativeName: 'Polski',
    dir: 'ltr',
    prompt:
      'Twoja lokalizacja: {country}. Czy chcesz poznać Superluxury lokalnie — z treściami i w języku dopasowanym do miejsca, w którym jesteś?',
    continueLabel: 'Dalej',
    closeLabel: 'Zamknij',
  },
  {
    code: 'ar',
    nativeName: 'العربية',
    dir: 'rtl',
    prompt: 'يبدو أنك في {country}. هل ترغب في تجربة Superluxury محليًا، بمحتوى ولغة يناسبان موقعك؟',
    continueLabel: 'متابعة',
    closeLabel: 'إغلاق',
  },
];

// Countries whose visitors are offered their own language in the suggestion banner
export const countryLocales: Record<string, Locale> = {
  DE: 'de',
  AT: 'de',
  CH: 'de',
  LI: 'de',
  FR: 'fr',
  BE: 'fr',
  MC: 'fr',
  LU: 'fr',
  PL: 'pl',
  AE: 'ar',
  SA: 'ar',
  QA: 'ar',
  KW: 'ar',
  BH: 'ar',
  OM: 'ar',
  EG: 'ar',
  JO: 'ar',
  LB: 'ar',
  MA: 'ar',
  DZ: 'ar',
  TN: 'ar',
  IQ: 'ar',
};

export const languageBannerStorageKey = 'sl-language-banner';
